import { createFileRoute } from '@tanstack/react-router'
import WorkforceAnalyticsDashboard from '@/features/workforce-analytics'

export const Route = createFileRoute('/_authenticated/workforce-analytics/')({
  component: WorkforceAnalyticsDashboard,
})
